import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'roleLabel', standalone: true })
export class RoleLabelPipe implements PipeTransform {
   transform(value?: string): string {
      if (!value) return '';
      return value
         .split('_')
         .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
         .join(' ');
   }
}
